import { render, staticRenderFns } from "./RecFlow.vue?vue&type=template&id=8c39a39a&scoped=true&"
import script from "./RecFlow.vue?vue&type=script&lang=js&"
export * from "./RecFlow.vue?vue&type=script&lang=js&"
import style0 from "./RecFlow.vue?vue&type=style&index=0&id=8c39a39a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c39a39a",
  null
  
)

export default component.exports